import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { TxBuchung, TxBuchungen, TxInfo } from '../../shared/interfaces/buchung';
import { TxApiService } from '../../shared/services/txapi.service';
import { FormatDate } from '../../shared/services/formatdate.service';
import { AuthService } from '../../shared/services/auth.service';
import { TabStates, TabStateService } from '../../shared/services/tabstate.service';
import { TxSession } from '../../shared/interfaces/session';
import { Store } from '@ngrx/store';
import { ReportEntity } from '../../store/entities/ReportEntity';
import { getReportList } from '../../store/selectors/reports.selectors';
import { TxreportapiService } from '../../shared/services/txreportapi.service';
import { tap, map } from 'rxjs/operators';
import { TxModalPdfComponent } from '../tx-modal-pdf/tx-modal-pdf.component';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { UserPermissionEntity } from '../../store/entities/UserPermissionEntity';
import { getPermissions } from '../../store/selectors/user.selectors';
import { HAS_MESSAGECENTER } from '../../store/entities/Permissions';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { EmployeeDocument, EmployeeDocumentsResponse } from '../../shared/interfaces/employee-document';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'tx-zeitkonto',
	templateUrl: './txzeitkonto.component.html',
	providers: [TabStateService],
	styleUrls: ['./tx-zeitkonto.component.scss'],
})
export class TxZeitkontoComponent implements OnInit, AfterViewInit {

	constructor(
		private readonly myTxApiserice: TxApiService,
		private readonly formatDate: FormatDate,
		public readonly myAuthService: AuthService,
		public myTabStateService: TabStateService,
		private readonly store: Store,
		private readonly reportService: TxreportapiService,
		private readonly dialog: MatDialog,
		private readonly translate: TranslateService
	) {
		this.reports$ = this.store.select(getReportList).pipe(
			map((reports) => reports.filter((report) => report.report_section === 'timeaccount')),
			filter((reports) => reports.length > 0)
		);

		this.userPermissions$ = this.store.select(getPermissions);
	}

	// Getter für Template-Zugriff
	get shouldShowBdeColumns(): boolean {
		return !this.showBdeColumns; // Umgekehrte Logik: true zeigt BDE-Spalten an
	}
	tabState: TabStates;

	// Material Table properties - Basis-Spalten
	private baseColumns: string[] = ['Datum', 'beginn', 'ende', 'soll', 'Diff', 'Summe', 'Tagesinfo'];
	private bdeColumns: string[] = ['bde_diff', 'bde_sum'];

	displayedColumns: string[] = [];
	dataSource = new MatTableDataSource<TxBuchung>([]);

	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	myBuchung: Array<TxBuchung>;
	myInfo;
	apiBuchungAnfrage: Observable<TxBuchungen>;
	apiInfoAnfrage: Observable<TxInfo>;

	buchungForm = 'Buchung';
	antragForm = 'Antrag';

	buchungsDate = '';

	session: TxSession;

	reports$: Observable<ReportEntity[]>;
	loadingReport = false;

	showMessageCenter = false;

	userPermissions$: Observable<string[]>;

	public has_message_center = HAS_MESSAGECENTER;

	// SYS_BDE Einstellung
	private showBdeColumns = false;
	private bde_active = false;

	// Employee Documents
	employeeDocuments: EmployeeDocument[] = [];
	loadingDocuments = false;
	hasEmployeeDocuments = false;

	// Short weekday i18n keys (reuse the existing txPlaning.* abbreviations),
	// indexed by Date.getDay() where 0 = Sunday. Used by the bookings list to
	// translate the weekday prefix instead of the LOCALE_ID-bound DatePipe 'EEE'.
	private weekdayKeys = ['txPlaning.su', 'txPlaning.mo', 'txPlaning.tu', 'txPlaning.we', 'txPlaning.th', 'txPlaning.fr', 'txPlaning.sa'];

	ngOnInit() {
		this.tabState = JSON.parse(localStorage.getItem('tabActives'));

		// SYS_BDE Einstellung laden und Spalten entsprechend setzen
		this.myTxApiserice.callAPI('getSetting', { settingName: 'SYS_BDE' }).subscribe(
			(response) => {
				this.showBdeColumns = !!response.settingValue;
				this.updateDisplayedColumns();
			},
			(error) => {
				console.error('Error loading SYS_BDE setting:', error);
				// Fallback: BDE-Spalten standardmäßig anzeigen
				this.showBdeColumns = true;
				this.updateDisplayedColumns();
			}
		);

		this.session = this.myAuthService.getSession();
		let myBuchungResponse: any;
		let myInfoResponse: any;
		const futureDate: any = new Date();
		futureDate.setDate(futureDate.getDate() + 7);
		const myBuchungRequestObject = { von: '2010-02-01T04:58:21', bis: FormatDate.createTxDate(futureDate) };
		const myInfoRequestObject = {};

		this.apiBuchungAnfrage = this.myTxApiserice.callAPI('getBuchung', myBuchungRequestObject);
		this.apiInfoAnfrage = this.myTxApiserice.callAPI('getSalden', myInfoRequestObject);

		this.apiBuchungAnfrage.subscribe(
			(myBuchungData) => {
				myBuchungResponse = myBuchungData;
				this.myBuchung = myBuchungData.Buchungen.sort((a, b) => {
					return a.Datum > b.Datum ? -1 : a.Datum < b.Datum ? 1 : 0;
				});

				if (this.myBuchung && this.myBuchung.length > 0 && this.myBuchung[0].bde_act !== undefined) {
					this.bde_active = !!this.myBuchung[0].bde_act;
					this.updateDisplayedColumns();
				}
				// Update the data source with the sorted data
				this.dataSource.data = this.myBuchung;
			},
			(error) => {
				console.log('ERROR' + error);
			}
		);

		this.apiInfoAnfrage.subscribe(
			(myInfoData) => {
				myInfoResponse = myInfoData;
				this.myInfo = myInfoData.ListOfSalden;
			},
			(error) => {
				console.log('ERROR' + error);
			}
		);

		// Load employee documents
		this.loadEmployeeDocuments();
	}

	ngAfterViewInit() {
		// Connect the paginator and sort to the data source
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
	}

	private updateDisplayedColumns(): void {
		if (this.showBdeColumns && this.bde_active) {
			// Wenn SYS_BDE true ist: BDE-Spalten anzeigen
			// BDE-Spalten vor 'Tagesinfo' einfügen
			const insertIndex = this.baseColumns.indexOf('Tagesinfo');
			this.displayedColumns = [
				...this.baseColumns.slice(0, insertIndex),
				...this.bdeColumns,
				...this.baseColumns.slice(insertIndex)
			];
		} else {
			// Wenn SYS_BDE false ist: BDE-Spalten NICHT anzeigen
			this.displayedColumns = [...this.baseColumns];
		}
	}

	hasPermission(permissions: string[], permission: string) {
		return permissions.includes(permission);
	}

	stopPropagation(event: Event) {
		event.stopImmediatePropagation();
		event.stopPropagation();
		return false;
	}

	print(): void {
		window.print();
	}

	isWeekend(date: any) {
		const currentDate = new Date(date);
		if (currentDate.getDay() === 6 || currentDate.getDay() === 0) {
			return true;
		}
	}

	weekdayKey(date: any): string {
		return this.weekdayKeys[new Date(date).getDay()];
	}

	isToday(date: any) {
		const currentDate = new Date(date);
		const todayDate = new Date();
		if (
			currentDate.getDate() === todayDate.getDate() &&
			currentDate.getMonth() === todayDate.getMonth() &&
			currentDate.getFullYear() === todayDate.getFullYear()
		) {
			return 'LightBlue';
		}
	}

	isNegative(hours: any) {
		if (hours) {
			if (hours.includes('-')) {
				return 'red';
			} else {
				return 'LimeGreen';
			}
		}
	}

	onTabOpen(name) {
		this.myTabStateService.onTabOpen(name);
	}

	onTabClose(name) {
		this.myTabStateService.onTabClose(name);
	}

	async downloadReport(report: ReportEntity) {
		this.loadingReport = true;

		const data = await firstValueFrom(this.reportService.getReport(report));
		this.dialog.open(TxModalPdfComponent, {
			minHeight: 'calc(100vh - 90px)',
			maxWidth: '95vw',
			height: 'auto',
			width: '1000px',
			data: {
				blob: data,
				title: report.report_name,
			},
		});
		this.loadingReport = false;
	}

	openChatDialog() {}

	/**
	 * Loads employee documents from the API
	 * Only displays the widget if documents are available
	 */
	loadEmployeeDocuments(): void {
		this.loadingDocuments = true;

		this.myTxApiserice.callAPI('getEmployeeDocument', {}).subscribe(
			(response: EmployeeDocumentsResponse) => {
				this.loadingDocuments = false;
				if (response && response.ListOfEmployeeDoc && response.ListOfEmployeeDoc.length > 0) {
					this.employeeDocuments = response.ListOfEmployeeDoc;
					this.hasEmployeeDocuments = true;
				} else {
					this.employeeDocuments = [];
					this.hasEmployeeDocuments = false;
				}
			},
			(error) => {
				console.error('Error loading employee documents:', error);
				this.loadingDocuments = false;
				this.hasEmployeeDocuments = false;
				this.employeeDocuments = [];
			}
		);
	}

	/**
	 * Triggers the backend to send the document to the user
	 * @param document The document to send
	 */
	sendEmployeeDocument(document: EmployeeDocument): void {
		if (!document || !document.document_id) {
			console.error('Invalid document');
			return;
		}

		// Set loading state for the specific document
		const docIndex = this.employeeDocuments.findIndex(d => d.document_id === document.document_id);
		if (docIndex !== -1) {
			this.employeeDocuments[docIndex].loading = true;
		}

		this.myTxApiserice.callAPI('sendEmployeeDocument', { document_id: document.document_id }).subscribe(
			(response) => {
				if (docIndex !== -1) {
					this.employeeDocuments[docIndex].loading = false;
				}
				
				if (response && response.statuscode === 0) {
					// Success - document sent
					console.log('Document sent successfully:', response);
					// Show success message to user
					alert(this.translate.instant('txZeitKonto.documentSentByMail'));
				} else {
					console.error('Error sending document:', response);
					// Show error message to user
					alert(this.translate.instant('txZeitKonto.documentSendError'));
				}
			},
			(error) => {
				if (docIndex !== -1) {
					this.employeeDocuments[docIndex].loading = false;
				}
				console.error('Error sending document:', error);
				// Show error message to user
				alert(this.translate.instant('txZeitKonto.documentSendError'));
			}
		);
	}
}
